// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/require-object-coercible.js
// module id = 178
// module chunks = 1